import Vue from 'vue'
import Router from 'vue-router'
import MobileClientPromResult from "../views/MobileClientPromResult.vue";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/cal',
      name: 'MobileClientPromResult',
      component: MobileClientPromResult,
      hidden: true,
      children:[],
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js